import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ERRORS } from "../consts";
import { fetcherFactory } from "../services";
import { useAuthStore } from "../stores";
import { getTimezoneFormattedDate } from "../utils/datetime";
import { getEnvironmentVariables } from "../utils/general";

const { basePath } = getEnvironmentVariables();

type SelectAlternativeRequest = {
  sectionId: number;
  selectedLearningObjectId: number;
};

export function useSelectLearningObjectAlternativeMutation() {
  const accessToken = useAuthStore(state => state.session?.getAccessToken().getJwtToken()) ?? "";
  const corporateId = useAuthStore(state => state.userData?.organization_id) ?? "";
  const initiativeId = useAuthStore(state => state.userData?.initiative_id) ?? "";
  const sessionToken = useAuthStore(state => state.sessionToken) ?? "";
  const setUnauthorized = useAuthStore(state => state.setUnAuthorized);
  const queryClient = useQueryClient();
  const fetcher = fetcherFactory();

  return useMutation({
    mutationFn: ({
      sectionId,
      selectedLearningObjectId
    }: SelectAlternativeRequest) => {
      const uri = `/learning-catalogue/${corporateId}/learning-objects/sections/${sectionId}/bookmark`;

      return fetcher(`${basePath}${uri}`, {
        body: JSON.stringify({ lo_id: selectedLearningObjectId }),
        headers: {
          "Authorization": accessToken,
          "content-type": "application/json",
          "x-ada-session-token": sessionToken,
          "x-user-timezone": getTimezoneFormattedDate()
        },
        method: "PUT"
      }).catch((error) => {
        if (error === ERRORS.UNAUTHORIZED) setUnauthorized(true);
        throw error;
      });
    },
    onSuccess: () => queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.some((key) =>
        typeof key === "string"
        && key.includes(`/learning-catalogue/${corporateId}/${initiativeId}/`)
      )
    })
  });
}
